import { postJSON, putJSON, getJSON } from '../utils/fetchUtils'

export function initApplication(data) {
  return postJSON(`/application/init/`, data)
}

export function updateApplication(data) {
  return putJSON(`/application/update/${data.application_id}/`, data)
}

export function getApplicationData({ applicationId }) {
  return getJSON(`/application/${applicationId}/`)
}

export function validateZipcode(zipcode) {
  return getJSON(`/zipcode/validate/?zip_code=${zipcode}`)
}

export function subscribeToStateWaitingList(data) {
  return postJSON(`/waiting-list/non-valid-state/`, data)
}

export function subscribeToEnrollmentReasonWaitingList(data) {
  return postJSON(`/waiting-list/enrollment-reason/`, data)
}


export function getQualificationReasons(locale) {
  return getJSON(`/qualification-reasons/?locale=${locale}`)
}
